import React, { useEffect, useState } from 'react';
import { Box, Typography, Grid, Divider, Stack } from '@mui/material';
import { useMediaQuery } from 'react-responsive';
import CustomAxios from '../utils/CustomAxios';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import { LinkHeader } from "../components/linkHeader";
import { useSelector } from 'react-redux';

const maskBankAccount = (acct) => {
    if (!acct || acct.length < 4) return '****';
    return acct.slice(0, -4).replace(/\d/g, '*') + acct.slice(-4);
};

const formatDate = (iso) => {
    if (!iso) return '-';
    const date = new Date(iso);
    return date.toLocaleDateString('en-GB');
};

export const MemberProfile = () => {
    const isExpanded = useSelector(state => state.executive.isExpanded);
    const isMobile = useMediaQuery({ maxWidth: 600 });
    const role = localStorage.getItem("role");
    const memberid = role === "member"
        ? parseInt(localStorage.getItem("memberid"))
        : JSON.parse(window.sessionStorage.getItem("search_memberid"))?.search_memberid;

    const [memberData, setMemberData] = useState(null);

    useEffect(() => {
        if (memberid) {
            CustomAxios.post("oasis/getmember/", { memberid })
                .then(res => setMemberData(res.data))
                .catch(err => console.error("Error fetching member profile", err));
        }
    }, [memberid]);

    const labelStyle = {
        fontSize: isMobile ? "12px" : "14px",
        fontWeight: 500,
        color: "#475569"
    };

    const valueStyle = {
        fontSize: isMobile ? "14px" : "16px",
        fontWeight: 600,
        color: "#1E293B"
    };

    // if (!memberData) return null;

    return (
        <Box sx={{width:"100%"}}>
            {role === "member" && <Header title="Member Profile" />}
            {(role === "staff" || role === "admin") && <LinkHeader title="Member Profile" />}
            <Box sx={{ display: { xs: "block", md: "flex" } }}>
                {!isMobile && <Sidebar />}
                <Box sx={{ p: 2, width: "100%" }}>
                    <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>Member Profile</Typography>

                    {memberData && <Grid container spacing={2}>
                        {[
                            { label: "Member ID", value: memberData.memberid },
                            { label: "Member Login No", value: memberData.oasis_id },
                            { label: "Member Name", value: memberData.membername },
                            { label: "Gender", value: memberData.sex },
                            { label: "Date of Birth", value: formatDate(memberData.dob) },
                            { label: "Date of Joining", value: formatDate(memberData.doj) },
                            { label: "Address - Line 1", value: memberData.add1 },
                            { label: "Address - Line 2", value: memberData.add2 },
                            { label: "Address - Line 3", value: memberData.add3 },
                            { label: "Address - Line 4", value: memberData.add4 },
                            { label: "Telephone (Home)", value: memberData.phoneno },
                            { label: "Telephone (Office)", value: memberData.phone2 },
                            { label: "Mobile No (HP)", value: memberData.mobileno },
                            { label: "WhatsApp No", value: memberData.whatsappno },
                            { label: "Email ID", value: memberData.emailid },
                            { label: "Old IC No / BC", value: memberData.oldicno },
                            { label: "MyKAD", value: memberData.newicno },
                            { label: "Race", value: memberData.race },
                            { label: "Member Nomination Form in File", value: memberData.nominationletter ? "Yes" : "No" },
                            // { label: "Death Certificate in File", value: memberData.deathcertfile ? "Yes" : "No" },
                            { label: "Nominee MyKAD Available", value: memberData.mykadnominee ? "Yes" : "No" },
                            { label: "Photocopy of MyKAD in File", value: memberData.status ? "Yes" : "No" },
                            { label: "Bank Name", value: memberData.m_bankname },
                            { label: "A/C Number", value: maskBankAccount(memberData.m_acctno) },
                            { label: "Occupation", value: memberData.occupation },
                            { label: "TIN No", value: memberData.tin_no }
                        ].map((item, idx) => (
                            <Grid item xs={12} sm={6} key={idx}>
                                <Typography sx={labelStyle}>{item.label}</Typography>
                                <Typography sx={valueStyle}>{item.value || "-"}</Typography>
                            </Grid>
                        ))}
                    </Grid>}

                    <Divider sx={{ my: 4 }} />

                    {memberData &&<> <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>Nominee Details</Typography>
                    {memberData.nominee_details?.length > 0 ? (
                        <Grid container spacing={2}>
                            {memberData.nominee_details.map((nom, idx) => (
                                <Grid item xs={12} key={idx}>
                                    <Stack spacing={1}>
                                        <Typography sx={labelStyle}>Name: <span style={valueStyle}>{nom.nomineename}</span></Typography>
                                        <Typography sx={labelStyle}>IC: <span style={valueStyle}>{nom.nomineeicno}</span></Typography>
                                        <Typography sx={labelStyle}>Relationship: <span style={valueStyle}>{nom.relationship}</span></Typography>
                                        <Typography sx={labelStyle}>Percentage: <span style={valueStyle}>{nom.percentage}%</span></Typography>
                                    </Stack>
                                    <Divider sx={{ my: 2 }} />
                                </Grid>
                            ))}
                        </Grid>
                    ) : (
                        <Typography sx={{ fontSize: "14px", color: "#64748B" }}>No nominee information available.</Typography>
                    )}
                    </>}
                </Box>
            </Box>
        </Box>
    );
};
